import { Modal } from "@mui/material";
import {
  getByFieldValue,
  isBlank,
  isEmptyList,
  isNullOrUndefined,
  sortByField,
} from "../../utils";

import { ReactComponent as Cross } from "../../assets/cross.svg";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import SearchSelector from "../SearchSelector";

function TemplateEventTypeModal(props) {
  const { isOpen, onClose, onAddOperationEvent, operation, eventTypes } = props;
  const { t } = useTranslation();

  const [selectedEventTypeUuid, setSelectedEventTypeUuid] = useState(null);

  function handleClose() {
    setSelectedEventTypeUuid(null);
    onClose();
  }
  const isValid = !isBlank(selectedEventTypeUuid);

  const filteredEventTypes = [];
  if (!isEmptyList(eventTypes) && !isNullOrUndefined(operation)) {
    eventTypes.forEach((i) => {
      const existingOperationEvent = getByFieldValue(
        operation?.events,
        "eventType.uuid",
        i.uuid
      );
      if (isNullOrUndefined(existingOperationEvent)) {
        filteredEventTypes.push(i);
      }
    });
    sortByField(filteredEventTypes, "name");
  }

  return (
    <div>
      <Modal open={isOpen} onClose={handleClose}>
        <div className="modal template-event-type-modal modal-50">
          <div>
            <div className="modal-header">
              <div>
                <h2>{t("add_operation_event")}</h2>
              </div>
              <div className="button-icon" onClick={handleClose}>
                <Cross />
              </div>
            </div>
          </div>
          <div className="modal-body">
            <div className="modal-container">
              <div className="template-event-type-modal-main">
                <div>
                  <div>
                    <label>{t("operation_event_type")}</label>
                  </div>
                  <div>
                    <SearchSelector
                      onSelect={(value) => {
                        setSelectedEventTypeUuid(value.uuid);
                      }}
                      items={filteredEventTypes}
                      searchableName="name"
                      selectedFieldName="uuid"
                      value={selectedEventTypeUuid}
                      allowClear={false}
                      size="small"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="modal-footer">
              <div>
                <button className="secondary" onClick={handleClose}>
                  {t("cancel")}
                </button>
              </div>
              <div>
                <button
                  onClick={() => {
                    const eventType = getByFieldValue(
                      eventTypes,
                      "uuid",
                      selectedEventTypeUuid
                    );
                    onAddOperationEvent(eventType);
                    handleClose();
                  }}
                  disabled={!isValid}
                >
                  {t("add_non_cap")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default TemplateEventTypeModal;
